/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedNote
 */
export interface PatchedNote {
    /**
     * 
     * @type {number}
     * @memberof PatchedNote
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedNote
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedNote
     */
    readonly createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedNote
     */
    readonly createdByName?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedNote
     */
    readonly contentType?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedNote
     */
    readonly contentTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedNote
     */
    objectType?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedNote
     */
    objectId?: number;
    /**
     * 
     * @type {Date}
     * @memberof PatchedNote
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedNote
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PatchedNote
     */
    readonly createdByAvatar?: string;
}

/**
 * Check if a given object implements the PatchedNote interface.
 */
export function instanceOfPatchedNote(value: object): value is PatchedNote {
    return true;
}

export function PatchedNoteFromJSON(json: any): PatchedNote {
    return PatchedNoteFromJSONTyped(json, false);
}

export function PatchedNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'content': json['content'] == null ? undefined : json['content'],
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'createdByName': json['created_by_name'] == null ? undefined : json['created_by_name'],
        'contentType': json['content_type'] == null ? undefined : json['content_type'],
        'contentTypeName': json['content_type_name'] == null ? undefined : json['content_type_name'],
        'objectType': json['object_type'] == null ? undefined : json['object_type'],
        'objectId': json['object_id'] == null ? undefined : json['object_id'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'createdByAvatar': json['created_by_avatar'] == null ? undefined : json['created_by_avatar'],
    };
}

  export function PatchedNoteToJSON(json: any): PatchedNote {
      return PatchedNoteToJSONTyped(json, false);
  }

  export function PatchedNoteToJSONTyped(value?: Omit<PatchedNote, 'id'|'created_by'|'created_by_name'|'content_type'|'content_type_name'|'created_at'|'updated_at'|'created_by_avatar'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'object_type': value['objectType'],
        'object_id': value['objectId'],
    };
}

